module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AceCycHkIKFuQAAAOhJREFUKM+tkTFKQ0EURc/82g0EFAtXYCcI4gbCRV5pkw0EIrqPFK5Ai3QD/0X3INi4gxQfQhaQ1uSnyZghOJIvud27993DGya4xzEw4jh6roAn4OMIsE/gMaTJPTbA2T9hC+BUsnXlHpN5CyyBtgOo3XZuJFu7R0Keusc+MO143Z1kdRqqDIZkb8B9B9hAsjp75Q4oWYJOgNcDYBPJXradHzOUtt1jDagQv0vW/y0IBVgAToAv4GIvngGXwFKy9iBgBu4B8729c8maUqf6A4ZkC+AK+AZWwLVkTf4JnZSK7nHoHh9yr6QNgmxSd+O9ucYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/drop-down-icon.png
// module id = 2374
// module chunks = 7